import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const STATUS_COLORS = {
  "Invitation": "bg-purple-100 text-purple-700 border-purple-200",
  "Estimating": "bg-yellow-100 text-yellow-700 border-yellow-200",
  "Estimate Complete": "bg-amber-100 text-amber-700 border-amber-200",
  "Bid Submitted": "bg-orange-100 text-orange-700 border-orange-200",
  "Budget Submitted": "bg-cyan-100 text-cyan-700 border-cyan-200",
  "Negotiating": "bg-green-100 text-green-700 border-green-200",
  "Won": "bg-blue-100 text-blue-700 border-blue-200",
  "Lost": "bg-red-100 text-red-700 border-red-200",
  "Cancelled": "bg-slate-200 text-slate-600 border-slate-300",
};

const DEFAULT = "bg-slate-100 text-slate-600 border-slate-200";

export function StatusBadge({ status }) {
  if (!status) return <span className="text-sm text-muted-foreground">--</span>;
  const colorClass = STATUS_COLORS[status] || DEFAULT;
  return (
    <Badge
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, '-')}`}
      className={cn(
        "rounded-full px-2.5 py-0.5 text-[11px] font-medium border whitespace-nowrap shadow-none",
        colorClass
      )}
    >
      {status}
    </Badge>
  );
}
